import * as Api from './api';

export function selectShipment(id) {
  return { type: 'SELECT_SHIPMENT', id };
}

export function requestPending() {
  return { type: 'REQUEST_PENDING' };
}

export function requestFinished() {
  return { type: 'REQUEST_FINISHED' };
}

export function requestError(error) {
  return { type: 'ERROR', error };
}

export function fetchTrackingData(embeddedWidgetId, orderId, zipCode) {
  return withApiActions(() => Api.getTrackingInfo(embeddedWidgetId, orderId, zipCode));
}

export function updateModelWithTracking(data) {
  return { type: 'UPDATE_MODEL', data };
}

export function fetchOrderDataForTrackingPage(trackingPageId, orderId, zipCode, language) {
  return withApiActions(() => Api.getOrderDataByTrackingPage(trackingPageId, orderId, zipCode, language));
}

export function fetchDummyOrderData(trackingPageId, language) {
  return withApiActions(() => Api.getDummyTrackingData(trackingPageId, language));
}

function withApiActions(fetchApi) {
  return (dispatch) => {
    dispatch(requestPending());
    fetchApi()
      .then((data) => {
        dispatch(updateModelWithTracking(data));
      })
      .catch((error) => dispatch(requestError(error)))
      .finally(() => dispatch(requestFinished()));
  };
}



// WEBPACK FOOTER //
// ./src/js/actions/tracking.js